import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SuccessIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
    >
      <g transform="translate(433 2669)">
        <circle cx="-421" cy="-2657" r="12" stroke="none" />
        <circle cx="-421" cy="-2657" r="11.25" />
      </g>
      <path
        d="m6.69 12.299 3.843 3.994 6.778-8.586"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};
